<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pt-1 pb-3 m-3 mx-0 px-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">
            Sample PO
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <div
            class="samplepo-panel col-auto d-flex justify-content-between gap-3 align-items-center"></div>
        </span>
      </span>

      <div class="col-12 p-3 pt-0 adduser-container-hgt">
        <form action="#" [formGroup]="samplePOForm">
          <div class="col-12" formGroupName="header">
            <div class="gray-bg-rounded mb-4">
              <div class="row">
                <div class="col mb-2 vendor-account">
                  <div class="form-group has-float-label" #mydrop>
                    <label class="form-label"
                      >Vendor Account<span class="madatory-field"
                        >*</span
                      ></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      id="vendoraccount"
                      name="vendoraccount"
                      class="form-control"
                      [value]="vendorAccountNumber"
                      formControlName="vendorAccountNumber"
                      (input)="searchVendor$.next($any($event.target).value)"
                      (keyup)="onVendorSearchOpenToggle($event, vendorPopover)"
                      [ngClass]="{
                        'has-error': formErrors['vendorAccountNumber'],
                      }"
                      (blur)="logValidationErrors()" />

                    <span
                      class="error-msg"
                      *ngIf="formErrors['vendorAccountNumber']">
                      {{ formErrors["vendorAccountNumber"] }}
                    </span>
                  </div>
                  <p-popover #vendorPopover aria-labelledby="dropdownBasic1">
                    <p-table
                      #dt
                      [value]="vendorList"
                      styleClass="p-datatable-customers po-small"
                      [rowHover]="true"
                      [rows]="10"
                      [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10, 25, 50]"
                      [paginator]="false"
                      [filterDelay]="0">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="name">Name</th>
                          <th class="vaccount">Vendor Account</th>
                          <th class="sname">Search name</th>
                          <th class="phone">Phone</th>
                          <th class="city">City</th>
                          <th class="state">State</th>
                          <th class="country">Country</th>
                        </tr>
                      </ng-template>
                      <ng-template
                        pTemplate="body"
                        let-vendorList
                        let-rowIndex="rowIndex">
                        <tr
                          class="p-selectable-row mousepointer"
                          (click)="
                            onVendorRowSelection(vendorList, vendorPopover)
                          ">
                          <td class="name mousepointer">
                            {{ vendorList.vendorName }}
                          </td>
                          <td class="vaccount mousepointer">
                            {{ vendorList.vendorAccountNumber }}
                          </td>
                          <td class="sname mousepointer">
                            {{ vendorList.vendorSearchName }}
                          </td>
                          <td class="phone mousepointer">
                            {{ vendorList.phoneNumber }}
                          </td>
                          <td class="city mousepointer">
                            {{ vendorList.city }}
                          </td>
                          <td class="state mousepointer">
                            {{ vendorList.state }}
                          </td>
                          <td class="country mousepointer">
                            {{ vendorList.country }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="20">No vendor found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </p-popover>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Job name</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="jobNameD365"
                      [ngClass]="{ 'has-error': formErrors['jobNameD365'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['jobNameD365']">
                      {{ formErrors["jobNameD365"] }}
                    </span>
                  </div>
                </div>
                <div class="col-3 mb-2 d-flex align-items-center">
                  <div class="form-group has-float-label me-2 date-field">
                    <label class="form-label">Ship date</label>
                    <p-datepicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      (onSelect)="onShipDateSelection($event)"
                      formControlName="expectedStoreAvailableSalesDateD365"
                      [minDate]="shipDateCurrentdate"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datepicker>
                  </div>
                  <div class="form-group has-float-label me-2 date-field">
                    <label class="form-label"
                      >In Hands date<span class="madatory-field">*</span></label
                    >
                    <p-datepicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      (onSelect)="onInHandDateSelection($event)"
                      formControlName="expectedStoreReceiptDateD365"
                      [ngClass]="{
                        'has-error': formErrors['expectedStoreReceiptDateD365'],
                      }"
                      (onBlur)="logValidationErrors()"
                      [minDate]="inHandDateCurrentdate"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datepicker>

                    <span
                      class="error-msg"
                      *ngIf="formErrors['expectedStoreReceiptDateD365']">
                      {{ formErrors["expectedStoreReceiptDateD365"] }}
                    </span>
                  </div>
                  <div
                    class="form-check d-flex gap-2 mt-4 justify-content-start">
                    <p-checkBox
                      type="checkbox"
                      formControlName="firm"
                      [binary]="true"
                      (onChange)="onFirmChange($event)" />
                    <label class="firm mt-2">Firm</label>
                  </div>
                </div>
                <div class="col mb-2 client-prospect" #client>
                  <div class="form-group has-float-label" id="dropdownBasic3">
                    <label class="form-label">client/prospect</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      id="clientprospect"
                      name="clientprospect"
                      class="form-control"
                      formControlName="clientProspectNumber"
                      (input)="searchClient$.next($any($event.target).value)"
                      (keyup)="
                        onClientSearchOpenToggle($event, clientPopover)
                      " />

                    <p-popover
                      [style]="{ width: '550px' }"
                      #clientPopover
                      aria-labelledby="dropdownBasic3">
                      <p-table
                        #clientdt
                        [value]="clientLists"
                        styleClass="p-datatable-customers po-small"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="name">Client</th>
                            <th class="vaccount">Account</th>
                            <th class="Phone" pSortableColumn="street">
                              Street
                              <p-sortIcon field="street"></p-sortIcon>
                            </th>
                            <th class="city" pSortableColumn="city">
                              City
                              <p-sortIcon field="city"></p-sortIcon>
                            </th>
                            <th class="state" pSortableColumn="state">
                              State
                              <p-sortIcon field="state"></p-sortIcon>
                            </th>
                            <th class="country">Last order date</th>
                          </tr>

                          <tr>
                            <th></th>
                            <th></th>
                            <th>
                              <div class="d-flex">
                                <input
                                  pInputText
                                  jniAutoCompleteBlocker
                                  pInputText
                                  type="text"
                                  name="street"
                                  id="street"
                                  style="max-width: 200px"
                                  (input)="
                                    clientdt.filter(
                                      $any($event.target).value,
                                      'street',
                                      'contains'
                                    )
                                  "
                                  placeholder=""
                                  class="p-column-filter p-inputtext p-component" />
                              </div>
                            </th>
                            <th>
                              <div class="d-flex">
                                <input
                                  pInputText
                                  jniAutoCompleteBlocker
                                  pInputText
                                  type="text"
                                  name="city"
                                  id="city"
                                  style="max-width: 200px"
                                  (input)="
                                    clientdt.filter(
                                      $any($event.target).value,
                                      'city',
                                      'contains'
                                    )
                                  "
                                  placeholder=""
                                  class="p-column-filter p-inputtext p-component" />
                              </div>
                            </th>
                            <th>
                              <div class="d-flex">
                                <input
                                  pInputText
                                  jniAutoCompleteBlocker
                                  pInputText
                                  type="text"
                                  name="state"
                                  id="state"
                                  style="max-width: 200px"
                                  (input)="
                                    clientdt.filter(
                                      $any($event.target).value,
                                      'state',
                                      'contains'
                                    )
                                  "
                                  placeholder=""
                                  class="p-column-filter p-inputtext p-component" />
                              </div>
                            </th>
                            <th></th>
                          </tr>
                        </ng-template>
                        <ng-template
                          pTemplate="body"
                          let-clientList
                          let-rowIndex="rowIndex">
                          <tr
                            class="p-selectable-row mousepointer"
                            (click)="
                              onClientSelection(clientList, clientPopover)
                            ">
                            <td class="name mousepointer">
                              {{ clientList.organizationNameD365 }}
                            </td>
                            <td class="vaccount mousepointer">
                              {{ clientList.clientAccount }}
                            </td>
                            <td style="width: 200px" class="sname mousepointer">
                              {{ clientList.street }}
                            </td>
                            <td class="city mousepointer">
                              {{ clientList.city }}
                            </td>
                            <td style="width: 75px" class="state mousepointer">
                              {{ clientList.state }}
                            </td>
                            <td
                              style="width: 75px"
                              class="country mousepointer">
                              {{
                                clientList.lastOrderDate | date: "yyyy-MM-dd"
                              }}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No client found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-popover>
                  </div>
                </div>
                <div class="col mb-2 brand-conslt">
                  <div
                    class="form-group has-float-label"
                    id="dropdownBasic4"
                    #bcdropdown>
                    <label class="form-label"
                      >Branding Consultant<span class="madatory-field"
                        >*</span
                      ></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      id="brandingConsultant"
                      name="brandingConsultant"
                      class="form-control"
                      formControlName="brandingConsultant"
                      (click)="onBrandingConsultantSelection($event, bcPopover)"
                      [ngClass]="{
                        'has-error': formErrors['brandingConsultant'],
                      }"
                      (blur)="logValidationErrors()" />

                    <span
                      class="error-msg"
                      *ngIf="formErrors['brandingConsultant']">
                      {{ formErrors["brandingConsultant"] }}
                    </span>
                    <p-popover #bcPopover aria-labelledby="dropdownBasic4">
                      <p-table
                        #dt
                        [value]="brandingConsultantLists"
                        styleClass="p-datatable-customers"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="name">Project id</th>
                            <th class="vaccount">Project name</th>
                          </tr>
                        </ng-template>
                        <ng-template
                          pTemplate="body"
                          let-brandingConsultantList
                          let-rowIndex="rowIndex">
                          <tr
                            class="p-selectable-row mousepointer"
                            (click)="
                              onProjectIdSelection(
                                brandingConsultantList,
                                bcPopover
                              )
                            ">
                            <td class="name mousepointer">
                              {{ brandingConsultantList.projectId }}
                            </td>
                            <td class="name mousepointer">
                              {{ brandingConsultantList.projectName }}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No project found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-popover>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Accounts coordinator</label>
                    <p-select
                      [(ngModel)]="bacUserDefaultSelectionId"
                      formControlName="bAC"
                      [options]="bacList"
                      optionLabel="name"
                      optionValue="personnelNumber"
                      [showClear]="true"
                      [filter]="true">
                      <ng-template let-option pTemplate="item">
                        {{ option.personnelNumber }} : {{ option.name }}
                      </ng-template>
                    </p-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="co-12">
            <div class="row">
              <div class="col-6 mb-3" formGroupName="header">
                <div class="gray-bg-rounded">
                  <h2 class="mb-2">Vendor</h2>
                  <div
                    class="form-group has-float-label mb-2"
                    (click)="onVendorModal()">
                    <label class="form-label">Vendor name</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control has-link"
                      placeholder=""
                      formControlName="vendorName" />
                  </div>
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label">Vendor Address</label>
                    <textarea
                      pInputText
                      jniAutoCompleteBlocker
                      placeholder=""
                      class="form-control"
                      formControlName="vendorAddress"></textarea>
                  </div>
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label">Phone number</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="vendorPhone" />
                  </div>
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label">Email Address</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="email"
                      class="form-control"
                      placeholder=""
                      formControlName="vendorEmail" />
                  </div>
                </div>
              </div>
              <div class="col-6 mb-3">
                <div class="gray-bg-rounded">
                  <h2 class="mb-2">Ship to</h2>
                  <jni-samplepo-ship-to-address
                    #samplepoaddress
                    [parent]="samplePOForm"
                    [formgroupName]="'addressInformation'"
                    [brandingConsultantObject]="brandingConsultantObject"
                    [customerBillToObject]="customerBillToObject"
                    [deliveryAddress]="deliveryAddress"
                    [cityList]="cityList"
                    [countryRegionList]="countryRegionList"
                    [countyList]="countyList"
                    [districtList]="districtList"
                    [formErrors]="formErrors"
                    [validationMessages]="validationMessages"
                    [addressField]="addressField"
                    (validationErrorEvent)="logValidationErrors()">
                  </jni-samplepo-ship-to-address>

                  <!-- <div class="form-group has-float-label mb-2">
              <div class="form-group has-float-label">
                <ng-select
                  
                  formControlName="deliveryAddressDescription"
                  (change)="onDeliveryAddressChange($event, shipaddress)"
                  [ngClass]="{
                    'has-error': formErrors.deliveryAddressDescription
                  }"
                  (blur)="logValidationErrors()"
                >
                  <ng-option
                    *ngFor="let com of deliveryAddress"
                    [value]="com.name"
                    [disabled]="com.status"
                  >
                    {{ com.name }}
                  </ng-option>
                </ng-select>
                <label class="form-label"
                  >Delivery Address <span class="madatory-field">*</span></label
                >
                <span
                  class="error-msg"
                  *ngIf="formErrors.deliveryAddressDescription"
                >
                  {{ formErrors.deliveryAddressDescription }}
                </span>
              </div>
            </div>
            <div class="ship-address" ngbDropdown #shipaddress="ngbDropdown">
              <div
                class="form-group has-float-label mb-2"
                *ngIf="shipToAddress"
                id="dropdownBasic2"
              >
                <input pInputText 
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  placeholder=""
                  [value]="shiftToAddressField"
                  (click)="onshipToAddressFilter($event, shipaddress)"
                />
                <label class="form-label">Client Ship To Name</label>
              </div>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                <ng-scrollbar style="height: 200px">
                  <p-table
                    #dt
                    [value]="shiftToAddressList"
                    styleClass="p-datatable-customers po-small"
                    [rowHover]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [paginator]="false"
                    [filterDelay]="0"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="name">Name and Description</th>
                        <th class="name">Address</th>
                        <th class="vaccount">Street</th>
                        <th class="sname">Purpose</th>
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-shiftToAddressLists
                      let-rowIndex="rowIndex"
                    >
                      <tr
                        class="p-selectable-row mousepointer"
                        (click)="
                          onShitToAddressSeletion(
                            shiftToAddressLists,
                            shipaddress
                          )
                        "
                      >
                        <td class="name mousepointer">
                          {{ shiftToAddressLists.descriptionD365 }}
                        </td>
                        <td class="name mousepointer">
                          {{ shiftToAddressLists.addressD365 }}
                        </td>
                        <td class="vaccount mousepointer">
                          {{ shiftToAddressLists.streetD365 }}
                        </td>
                        <td class="sname mousepointer">
                          {{ shiftToAddressLists.rolesD365 }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="20">No address found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </ng-scrollbar>
              </div>
            </div>
            <div class="v-account" ngbDropdown #vendoracount="ngbDropdown">
              <div
                class="form-group has-float-label mb-2"
                *ngIf="vendorAccountAndBook"
                id="dropdownBasic5"
              >
                <input pInputText 
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  placeholder=""
                  [value]="vendorAccountSeletion"
                  (input)="searchVendor$.next($any($event.target).value)"
                  (keypress)="onVendorSearchOpenToggle(vendoracount)"
                />
                <label class="form-label">Vendor Account</label>
              </div>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                <ng-scrollbar style="height: 200px">
                  <p-table
                    #dt
                    [value]="vendorList"
                    styleClass="p-datatable-customers po-small"
                    [rowHover]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [paginator]="false"
                    [filterDelay]="0"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="name">Name or description</th>
                        <th class="vaccount">Address</th>
                        <th class="sname">Purpose</th>
                        <th class="sname">Primary</th>
                        <th class="sname">Val</th>
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-vendorList
                      let-rowIndex="rowIndex"
                    >
                      <tr
                        class="p-selectable-row mousepointer"
                        (click)="
                          onVendorAccountSelection(
                            vendorList,
                            vendoracount,
                            vendoraddressbook
                          )
                        "
                      >
                        <td class="name mousepointer">
                          {{ vendorList.vendorName }}
                        </td>
                        <td class="vaccount mousepointer">
                          {{ vendorList.addressD365 }}
                        </td>
                        <td class="sname mousepointer">
                          {{ vendorList.purpose }}
                        </td>
                        <td class="sname mousepointer">
                          {{ vendorList.primary }}
                        </td>
                        <td class="sname mousepointer">
                          <input pInputText 
                            [disabled]="true"
                            class="form-check-input me-2"
                            type="checkbox"
                          />
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="20">No address found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </ng-scrollbar>
              </div>
            </div>
            <div ngbDropdown #vendoraddressbook="ngbDropdown">
              <div
                class="form-group has-float-label mb-2"
                *ngIf="vendorAccountAndBook"
                id="dropdownBasic6"
              >
                <input pInputText 
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  placeholder=""
                  [value]="addressBookName"
                  (click)="onVendorAddressBookSelect(vendoraddressbook)"
                />
                <label class="form-label">Vendor Address Book</label>
              </div>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
                <p-table
                  #dt
                  [value]="addressBookList"
                  styleClass="p-datatable-customers po-small"
                  [rowHover]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [paginator]="false"
                  [filterDelay]="0"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="vaccount">Address</th>
                      <th class="sname">Purpose</th>
                      <th class="sname">Street</th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-addressBookLists
                    let-rowIndex="rowIndex"
                  >
                    <tr
                      class="p-selectable-row mousepointer"
                      (click)="
                        onVendorAddressBookSelection(
                          addressBookLists,
                          vendoraddressbook
                        )
                      "
                    >
                      <td class="vaccount mousepointer">
                        {{ addressBookLists.addressD365 }}
                      </td>
                      <td class="sname mousepointer">
                        {{
                          addressBookLists.purposeD365 === '1'
                            ? 'Busniess'
                            : 'Others'
                        }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ addressBookLists.streetD365 }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="20">No address found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            <div class="form-group has-float-label mb-2">
              <input pInputText 
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="attentionInformationD365"
              />
              <label class="form-label">Attention</label>
            </div>
            <div class="form-group has-float-label mb-2">
              <input pInputText 
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="locationD365"
              />
              <label class="form-label">location</label>
            </div>
            <div
              class="form-group has-float-label mb-2"
              [hidden]="!showAddress"
            >
              <textarea pInputText
                jniAutoCompleteBlocker
                placeholder=""
                class="form-control"
                formControlName="addressD365"
              ></textarea>
              <label class="form-label">Address</label>
            </div>

            <jni-address
              *ngIf="showAddressComponent()"
              [parent]="samplePOForm"
              [cityList]="cityList"
              [countryRegionList]="countryRegionList"
              [countyList]="countyList"
              [districtList]="districtList"
              [formgroupName]="'addressInformation'"
              [hiddenHeadingStatus]="true"
            >
            </jni-address>
            <div class="form-group has-float-label mt-3">
              <input pInputText 
                jniAutoCompleteBlocker
                type="email"
                class="form-control"
                placeholder=""
                formControlName="shipToEmail"
              />
              <label class="form-label">Ship to email</label>
            </div> -->
                </div>
              </div>
              <div class="col-6" formGroupName="header">
                <div class="gray-bg-rounded">
                  <h2 class="mb-2">Details</h2>
                  <div class="form-group has-float-label mb-2">
                    <div class="form-group has-float-label">
                      <label class="form-label">Shipping Method</label>
                      <p-select
                        id="currency"
                        formControlName="deliveryModeIdD365"
                        (onChange)="onShippingMethodSelect($event)"
                        [options]="shippingProductsList"
                        optionLabel="modeDescriptionD365"
                        optionValue="modeCodeD365"
                        [showClear]="true"
                        [filter]="true">
                      </p-select>
                    </div>
                  </div>
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label">Account #</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="accountNumber" />
                  </div>
                  <div
                    class="form-group has-float-label mb-2 d-flex align-items-center gap-2">
                    <p-checkbox
                      type="checkbox"
                      class="mt-3"
                      formControlName="isnetInForeignCurrencyStatus"
                      (onChange)="onCurrencyEnable($event)" />
                    <div class="form-group has-float-label flex-grow-1">
                      <label class="form-label">Net in Foreign Currency</label>
                      <p-select
                        id="currency"
                        formControlName="currencyCodeD365"
                        (onChange)="onCurrencyConversion()"
                        [options]="currencyList"
                        optionLabel="isoCurrencyCodeD365"
                        optionValue="isoCurrencyCodeD365"
                        [showClear]="true"
                        [filter]="true">
                      </p-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="gray-bg-rounded">
                  <jni-add-line
                    [parent]="samplePOForm"
                    [currencyConversion]="currencyConversion"
                    [shipDateOne]="shipDateOne"
                    [inHandDateCurrentdate]="inHandDateCurrentdate"
                    [inHandDateOne]="inHandDateOne"
                    [firmOneCheckBox]="firmOneCheckBox"
                    [currencyConversionStatus]="showForeignCurrency"
                    [formErrors]="formErrors"
                    (validationEvent)="logValidationErrors()"
                    (showPositionDialogDescriptionEvent)="
                      showPositionDialogDescription($event)
                    "
                    (showPositionDialogFactoryEvent)="
                      showPositionDialogFactory($event)
                    "></jni-add-line>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex py-3 justify-content-end has-sticky gap-3">
            <!-- <button
              type="button"
              class="btn btn-secondary me-3"
              (click)="onCancel()">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="addSamplePoScreen()">
              Save
            </button> -->

            <p-button
              label="Cancel"
              (click)="onCancel()"
              variant="outlined"
              severity="secondary" />

            <p-button label="Save" (click)="addSamplePoScreen()" />
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>

<jni-stock-phrases
  #stockPhraseDescription
  [flag]="'description'"
  [displayPosition]="displayPositionDescription"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogDescription()"
  (notesAndFactEvent)="getDescription($event)"></jni-stock-phrases>

<jni-stock-phrases
  #stockPhraseFactory
  [flag]="'factory'"
  [displayPosition]="displayPositionFactory"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogFactory()"
  (notesAndFactEvent)="getFactory($event)"></jni-stock-phrases>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"></jni-vendor-summary>
  </div>
</jni-modal-stacker>
